export default __webpack_public_path__ + "static/media/sensotrend_connect_view_data.65219749.png";